export const GuestTypes = ['day', 'overnight', 'donation'] as const;
// type GuestType = 'day' | 'overnight' | 'donation';
type GuestType = typeof GuestTypes[number];
export const GuestTypesEnum = Object.fromEntries(GuestTypes.map(guestType => [guestType, guestType]));
export default GuestType;